module.exports = __webpack_public_path__ + "static/img/V3-2.e1727a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/langPack/20200000/V3-2.png
// module id = czkA
// module chunks = 1